export default __webpack_public_path__ + "static/media/javascript.b77c85de.svg";